import en from 'date-format-parse/lib/locale/en';

const lang = {
  formatLocale: en,
  yearFormat: 'YYYY',
  monthFormat: 'MMM',
  monthBeforeYear: true,
};

export default lang;
